<template>
  <entity-detail-presentation
    :entity-id="state.entityId"
    :name="state.name"
    :disambiguation="state.disambiguation"
    :type-list="state.typeList"
    :description="state.description"
    :attributes-list="state.attributesList"
    :relation-entities-list="state.relationEntitiesList"
    :ready="state.isEntityReady && state.isRelationReady"
    @entity-click="handleEntityClick"
  />
</template>

<script setup>
import { defineProps, onMounted, reactive, watch } from "vue";
import { useStore } from "vuex";
import { httpPost } from "@/api/httpService";
import { searchEntityRelationAgg } from "@/api/graphApi";
import EntityDetailPresentation from "@/components/entity/EntityDetailPresentation.vue";

const store = useStore();

const props = defineProps({
  entityId: {
    type: String,
  },
});

const defaultRelationEntityNum = 5;

const state = reactive({
  isEntityReady: false,
  isRelationReady: false,
  entityId: "",
  name: "",
  disambiguation: "",
  typeList: [],
  description: "",
  attributesList: [],
  relationEntitiesList: [],
});

function initRelationShowNums() {
  for (let r = 0; r < state.relationEntitiesList.length; r++) {
    state.relationEntitiesList[r].showNum = defaultRelationEntityNum;
    state.relationEntitiesList[r].incomingShowNum = defaultRelationEntityNum;
    state.relationEntitiesList[r].outgoingShowNum = defaultRelationEntityNum;
    for (
      let i = 0;
      i < state.relationEntitiesList[r].relationList.length;
      i++
    ) {
      state.relationEntitiesList[r].relationList[i].selected = false;
    }
  }
}

async function searchEntityDetail() {
  state.isEntityReady = false;
  const res = await httpPost("/graph/v1/searchEntityDetail", {
    entityId: props.entityId,
  });
  if (res.code == 0) {
    state.entityId = res.data.entityId;
    state.name = res.data.name;
    state.disambiguation = res.data.disambiguation;
    state.typeList = res.data.typeList;
    state.description = res.data.description;
    state.attributesList = res.data.attributesList;
    state.isEntityReady = true;
  }
}

async function searchEntityRelationAggData() {
  state.isRelationReady = false;
  const res = await searchEntityRelationAgg(props.entityId, null);
  if (res.code == 0) {
    state.relationEntitiesList = res.data || [];
    initRelationShowNums();
    state.isRelationReady = true;
  }
}

function handleEntityClick({ relationItem, entityId }) {
  for (let r = 0; r < state.relationEntitiesList.length; r++) {
    for (
      let i = 0;
      i < state.relationEntitiesList[r].relationList.length;
      i++
    ) {
      state.relationEntitiesList[r].relationList[i].selected = false;
    }
  }
  relationItem.selected = true;
  store.commit("handleIdForDetailCardChange", entityId);
  store.commit("handletTypeForDetailCardChange", "entity");
  store.commit("handleDetailShow");
}

async function loadAll() {
  if (!props.entityId) {
    return;
  }
  await Promise.all([searchEntityDetail(), searchEntityRelationAggData()]);
}

onMounted(() => {
  loadAll();
});

watch(
  () => props.entityId,
  () => {
    loadAll();
  }
);
</script>
